// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as CompressGifForDiscordRouteImport } from './routes/compress-gif-for-discord'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as GifCompressorRouteImport } from './routes/gif-compressor'
import { Route as GifCropperRouteImport } from './routes/gif-cropper'
import { Route as GifResizerRouteImport } from './routes/gif-resizer'
import { Route as GifSpeedChangerRouteImport } from './routes/gif-speed-changer'
import { Route as GifSplitterRouteImport } from './routes/gif-splitter'
import { Route as GifToPngRouteImport } from './routes/gif-to-png'
import { Route as GifTrimmerRouteImport } from './routes/gif-trimmer'
import { Route as PngToGifRouteImport } from './routes/png-to-gif'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as LangIndexRouteImport } from './routes/$lang/index'
import { Route as LangAboutRouteImport } from './routes/$lang/about'
import { Route as LangCompressGifForDiscordRouteImport } from './routes/$lang/compress-gif-for-discord'
import { Route as LangContactRouteImport } from './routes/$lang/contact'
import { Route as LangGifCompressorRouteImport } from './routes/$lang/gif-compressor'
import { Route as LangGifCropperRouteImport } from './routes/$lang/gif-cropper'
import { Route as LangGifResizerRouteImport } from './routes/$lang/gif-resizer'
import { Route as LangGifSpeedChangerRouteImport } from './routes/$lang/gif-speed-changer'
import { Route as LangGifSplitterRouteImport } from './routes/$lang/gif-splitter'
import { Route as LangGifToPngRouteImport } from './routes/$lang/gif-to-png'
import { Route as LangGifTrimmerRouteImport } from './routes/$lang/gif-trimmer'
import { Route as LangPngToGifRouteImport } from './routes/$lang/png-to-gif'
import { Route as LangPrivacyRouteImport } from './routes/$lang/privacy'
import { Route as LangTermsRouteImport } from './routes/$lang/terms'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogBestFreeGifMakerRouteImport } from './routes/blog.best-free-gif-maker'
import { Route as BlogHowLongCanAGifBeRouteImport } from './routes/blog.how-long-can-a-gif-be'
import { Route as BlogHowManyFpsAreGifsRouteImport } from './routes/blog.how-many-fps-are-gifs'
import { Route as BlogHowToAnimateAPngRouteImport } from './routes/blog.how-to-animate-a-png'
import { Route as BlogHowToCropAGifRouteImport } from './routes/blog.how-to-crop-a-gif'
import { Route as BlogHowToMakeAGifFromImagesRouteImport } from './routes/blog.how-to-make-a-gif-from-images'
import { Route as BlogHowToMakeAGifFromVideoRouteImport } from './routes/blog.how-to-make-a-gif-from-video'
import { Route as BlogHowToMakeAGifIntoAStickerRouteImport } from './routes/blog.how-to-make-a-gif-into-a-sticker'
import { Route as BlogHowToMakeAGifSizeSmallerRouteImport } from './routes/blog.how-to-make-a-gif-size-smaller'
import { Route as BlogHowToResizeAGifRouteImport } from './routes/blog.how-to-resize-a-gif'
import { Route as BlogHowToSlowDownAGifRouteImport } from './routes/blog.how-to-slow-down-a-gif'
import { Route as BlogWhyIsMyGifSoBigRouteImport } from './routes/blog.why-is-my-gif-so-big'
import { Route as ResearchGifCompressionTestRouteImport } from './routes/research.gif-compression-test'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const CompressGifForDiscordRoute = CompressGifForDiscordRouteImport.update({
            id: '/compress-gif-for-discord',path: '/compress-gif-for-discord',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const GifCompressorRoute = GifCompressorRouteImport.update({
            id: '/gif-compressor',path: '/gif-compressor',getParentRoute: () => rootRouteImport
          })
const GifCropperRoute = GifCropperRouteImport.update({
            id: '/gif-cropper',path: '/gif-cropper',getParentRoute: () => rootRouteImport
          })
const GifResizerRoute = GifResizerRouteImport.update({
            id: '/gif-resizer',path: '/gif-resizer',getParentRoute: () => rootRouteImport
          })
const GifSpeedChangerRoute = GifSpeedChangerRouteImport.update({
            id: '/gif-speed-changer',path: '/gif-speed-changer',getParentRoute: () => rootRouteImport
          })
const GifSplitterRoute = GifSplitterRouteImport.update({
            id: '/gif-splitter',path: '/gif-splitter',getParentRoute: () => rootRouteImport
          })
const GifToPngRoute = GifToPngRouteImport.update({
            id: '/gif-to-png',path: '/gif-to-png',getParentRoute: () => rootRouteImport
          })
const GifTrimmerRoute = GifTrimmerRouteImport.update({
            id: '/gif-trimmer',path: '/gif-trimmer',getParentRoute: () => rootRouteImport
          })
const PngToGifRoute = PngToGifRouteImport.update({
            id: '/png-to-gif',path: '/png-to-gif',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const LangIndexRoute = LangIndexRouteImport.update({
            id: '/$lang/',path: '/$lang/',getParentRoute: () => rootRouteImport
          })
const LangAboutRoute = LangAboutRouteImport.update({
            id: '/$lang/about',path: '/$lang/about',getParentRoute: () => rootRouteImport
          })
const LangCompressGifForDiscordRoute = LangCompressGifForDiscordRouteImport.update({
            id: '/$lang/compress-gif-for-discord',path: '/$lang/compress-gif-for-discord',getParentRoute: () => rootRouteImport
          })
const LangContactRoute = LangContactRouteImport.update({
            id: '/$lang/contact',path: '/$lang/contact',getParentRoute: () => rootRouteImport
          })
const LangGifCompressorRoute = LangGifCompressorRouteImport.update({
            id: '/$lang/gif-compressor',path: '/$lang/gif-compressor',getParentRoute: () => rootRouteImport
          })
const LangGifCropperRoute = LangGifCropperRouteImport.update({
            id: '/$lang/gif-cropper',path: '/$lang/gif-cropper',getParentRoute: () => rootRouteImport
          })
const LangGifResizerRoute = LangGifResizerRouteImport.update({
            id: '/$lang/gif-resizer',path: '/$lang/gif-resizer',getParentRoute: () => rootRouteImport
          })
const LangGifSpeedChangerRoute = LangGifSpeedChangerRouteImport.update({
            id: '/$lang/gif-speed-changer',path: '/$lang/gif-speed-changer',getParentRoute: () => rootRouteImport
          })
const LangGifSplitterRoute = LangGifSplitterRouteImport.update({
            id: '/$lang/gif-splitter',path: '/$lang/gif-splitter',getParentRoute: () => rootRouteImport
          })
const LangGifToPngRoute = LangGifToPngRouteImport.update({
            id: '/$lang/gif-to-png',path: '/$lang/gif-to-png',getParentRoute: () => rootRouteImport
          })
const LangGifTrimmerRoute = LangGifTrimmerRouteImport.update({
            id: '/$lang/gif-trimmer',path: '/$lang/gif-trimmer',getParentRoute: () => rootRouteImport
          })
const LangPngToGifRoute = LangPngToGifRouteImport.update({
            id: '/$lang/png-to-gif',path: '/$lang/png-to-gif',getParentRoute: () => rootRouteImport
          })
const LangPrivacyRoute = LangPrivacyRouteImport.update({
            id: '/$lang/privacy',path: '/$lang/privacy',getParentRoute: () => rootRouteImport
          })
const LangTermsRoute = LangTermsRouteImport.update({
            id: '/$lang/terms',path: '/$lang/terms',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogBestFreeGifMakerRoute = BlogBestFreeGifMakerRouteImport.update({
            id: '/blog/best-free-gif-maker',path: '/blog/best-free-gif-maker',getParentRoute: () => rootRouteImport
          })
const BlogHowLongCanAGifBeRoute = BlogHowLongCanAGifBeRouteImport.update({
            id: '/blog/how-long-can-a-gif-be',path: '/blog/how-long-can-a-gif-be',getParentRoute: () => rootRouteImport
          })
const BlogHowManyFpsAreGifsRoute = BlogHowManyFpsAreGifsRouteImport.update({
            id: '/blog/how-many-fps-are-gifs',path: '/blog/how-many-fps-are-gifs',getParentRoute: () => rootRouteImport
          })
const BlogHowToAnimateAPngRoute = BlogHowToAnimateAPngRouteImport.update({
            id: '/blog/how-to-animate-a-png',path: '/blog/how-to-animate-a-png',getParentRoute: () => rootRouteImport
          })
const BlogHowToCropAGifRoute = BlogHowToCropAGifRouteImport.update({
            id: '/blog/how-to-crop-a-gif',path: '/blog/how-to-crop-a-gif',getParentRoute: () => rootRouteImport
          })
const BlogHowToMakeAGifFromImagesRoute = BlogHowToMakeAGifFromImagesRouteImport.update({
            id: '/blog/how-to-make-a-gif-from-images',path: '/blog/how-to-make-a-gif-from-images',getParentRoute: () => rootRouteImport
          })
const BlogHowToMakeAGifFromVideoRoute = BlogHowToMakeAGifFromVideoRouteImport.update({
            id: '/blog/how-to-make-a-gif-from-video',path: '/blog/how-to-make-a-gif-from-video',getParentRoute: () => rootRouteImport
          })
const BlogHowToMakeAGifIntoAStickerRoute = BlogHowToMakeAGifIntoAStickerRouteImport.update({
            id: '/blog/how-to-make-a-gif-into-a-sticker',path: '/blog/how-to-make-a-gif-into-a-sticker',getParentRoute: () => rootRouteImport
          })
const BlogHowToMakeAGifSizeSmallerRoute = BlogHowToMakeAGifSizeSmallerRouteImport.update({
            id: '/blog/how-to-make-a-gif-size-smaller',path: '/blog/how-to-make-a-gif-size-smaller',getParentRoute: () => rootRouteImport
          })
const BlogHowToResizeAGifRoute = BlogHowToResizeAGifRouteImport.update({
            id: '/blog/how-to-resize-a-gif',path: '/blog/how-to-resize-a-gif',getParentRoute: () => rootRouteImport
          })
const BlogHowToSlowDownAGifRoute = BlogHowToSlowDownAGifRouteImport.update({
            id: '/blog/how-to-slow-down-a-gif',path: '/blog/how-to-slow-down-a-gif',getParentRoute: () => rootRouteImport
          })
const BlogWhyIsMyGifSoBigRoute = BlogWhyIsMyGifSoBigRouteImport.update({
            id: '/blog/why-is-my-gif-so-big',path: '/blog/why-is-my-gif-so-big',getParentRoute: () => rootRouteImport
          })
const ResearchGifCompressionTestRoute = ResearchGifCompressionTestRouteImport.update({
            id: '/research/gif-compression-test',path: '/research/gif-compression-test',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,CompressGifForDiscordRoute: CompressGifForDiscordRoute,ContactRoute: ContactRoute,GifCompressorRoute: GifCompressorRoute,GifCropperRoute: GifCropperRoute,GifResizerRoute: GifResizerRoute,GifSpeedChangerRoute: GifSpeedChangerRoute,GifSplitterRoute: GifSplitterRoute,GifToPngRoute: GifToPngRoute,GifTrimmerRoute: GifTrimmerRoute,PngToGifRoute: PngToGifRoute,PrivacyRoute: PrivacyRoute,TermsRoute: TermsRoute,LangAboutRoute: LangAboutRoute,LangCompressGifForDiscordRoute: LangCompressGifForDiscordRoute,LangContactRoute: LangContactRoute,LangGifCompressorRoute: LangGifCompressorRoute,LangGifCropperRoute: LangGifCropperRoute,LangGifResizerRoute: LangGifResizerRoute,LangGifSpeedChangerRoute: LangGifSpeedChangerRoute,LangGifSplitterRoute: LangGifSplitterRoute,LangGifToPngRoute: LangGifToPngRoute,LangGifTrimmerRoute: LangGifTrimmerRoute,LangPngToGifRoute: LangPngToGifRoute,LangPrivacyRoute: LangPrivacyRoute,LangTermsRoute: LangTermsRoute,BlogBestFreeGifMakerRoute: BlogBestFreeGifMakerRoute,BlogHowLongCanAGifBeRoute: BlogHowLongCanAGifBeRoute,BlogHowManyFpsAreGifsRoute: BlogHowManyFpsAreGifsRoute,BlogHowToAnimateAPngRoute: BlogHowToAnimateAPngRoute,BlogHowToCropAGifRoute: BlogHowToCropAGifRoute,BlogHowToMakeAGifFromImagesRoute: BlogHowToMakeAGifFromImagesRoute,BlogHowToMakeAGifFromVideoRoute: BlogHowToMakeAGifFromVideoRoute,BlogHowToMakeAGifIntoAStickerRoute: BlogHowToMakeAGifIntoAStickerRoute,BlogHowToMakeAGifSizeSmallerRoute: BlogHowToMakeAGifSizeSmallerRoute,BlogHowToResizeAGifRoute: BlogHowToResizeAGifRoute,BlogHowToSlowDownAGifRoute: BlogHowToSlowDownAGifRoute,BlogWhyIsMyGifSoBigRoute: BlogWhyIsMyGifSoBigRoute,ResearchGifCompressionTestRoute: ResearchGifCompressionTestRoute,LangIndexRoute: LangIndexRoute,BlogIndexRoute: BlogIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)